import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {BreadcrumbModule} from 'angular-crumbs';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { MaterialModule } from './components/material.module';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { CustomFilterPipe } from './pipes/custom-filter.pipe';
import { SanatizeHtmlPipe } from './pipes/sanatize-html.pipe';
import { HScrollDirective } from './directives/h-scroll.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
// import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { SocialShareComponent } from './components/social-share/social-share.component';
import { BsModalRef, ModalModule } from 'ngx-bootstrap/modal';
// import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { NgxSmoothScrollModule } from '@boatzako/ngx-smooth-scroll';
import { PerfectScrollbarConfigInterface, PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { RemoveHiphenPipe } from './pipes/remove-hiphen.pipe';
import { BasePopupComponent } from './components/base-popup/base-popup.component';
import { CommentChildListComponent } from './components/comments/comment-child-list/comment-child-list.component';
import { CommentListComponent } from './components/comments/comment-list/comment-list.component';
import { CommentSectionComponent } from './components/comments/comment-section/comment-section.component';
import { CreateCommentComponent } from './components/comments/create-comment/create-comment.component';
import { McqComponent } from './components/mcq/mcq.component';
import { PostCardComponent } from './components/post-card/post-card.component';
import { IntersectionObserverDirective } from './directives/intersection-observer.directive';
import { PreviewPostImageComponent } from './components/preview-post-image/preview-post-image.component';
import { CreateDiscussModalComponent } from './components/create-discuss-modal/create-discuss-modal.component';
import { CreatePostComponent } from './components/create-post/create-post.component';
import { CreateStoryModalComponent } from './components/create-story-modal/create-story-modal.component';
import { StoryViewListPopupComponent } from './components/story-view-list-popup/story-view-list-popup.component';
import { StoriesPanelComponent } from './components/stories-panel/stories-panel.component';
import { DiscussFilterComponent } from './components/discuss-filter/discuss-filter.component';
import { PaymentsComponent } from './components/payments/payments.component';
import { ExternalLibraryService } from './components/util';
import { HorizontalDatePickerComponent } from './components/horizontal-date-picker/horizontal-date-picker.component';
import { SafeUrlPipe } from './pipes/safe-url-pipe';
import { CourseFilterPipe } from './pipes/course-filter.pipe';
import { LazyImgDirective } from './directives/lazyimg.directive';
import { LeftFilterPanelComponent } from './components/left-filter-panel/left-filter-panel.component';
import { BarRatingModule } from 'ngx-bar-rating';

const sharedRoutes:Routes=[];

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  declarations: [BreadcrumbComponent, FooterComponent, HeaderComponent,SocialShareComponent,RemoveHiphenPipe,SafeUrlPipe,
    CommentChildListComponent,PaymentsComponent,
    CommentListComponent,
    CommentSectionComponent,
    CreateCommentComponent,
    McqComponent,
    CreatePostComponent,
    PreviewPostImageComponent,
    CreateDiscussModalComponent,
    CreateStoryModalComponent,
    PostCardComponent,
    CustomFilterPipe,
    CourseFilterPipe,
    StoriesPanelComponent,
    LeftFilterPanelComponent,
    SanatizeHtmlPipe,HScrollDirective,IntersectionObserverDirective, BasePopupComponent,StoryViewListPopupComponent,DiscussFilterComponent,HorizontalDatePickerComponent,
    LazyImgDirective],
  imports: [
    CommonModule,
    MaterialModule,
    BreadcrumbModule,
    ReactiveFormsModule,
    FormsModule,
    ModalModule.forRoot(),
    // ShareButtonsModule,
    // ShareIconsModule,
    NgxSmoothScrollModule,
    PerfectScrollbarModule,
    BarRatingModule,
    RouterModule.forChild(sharedRoutes)
  ],
  exports:[BreadcrumbComponent, FooterComponent, HeaderComponent,SocialShareComponent,CustomFilterPipe,CourseFilterPipe, RemoveHiphenPipe,SafeUrlPipe,
    CommentChildListComponent,PaymentsComponent,
    CommentListComponent,
    CommentSectionComponent,
    CreateCommentComponent,
    PostCardComponent,
    McqComponent,
    CreatePostComponent,
    CreateDiscussModalComponent,
    CreateStoryModalComponent,
    StoriesPanelComponent,
    PreviewPostImageComponent,
    LeftFilterPanelComponent,
    SanatizeHtmlPipe,HScrollDirective,IntersectionObserverDirective,StoryViewListPopupComponent,DiscussFilterComponent,HorizontalDatePickerComponent],
  entryComponents: [SocialShareComponent ,CreateDiscussModalComponent,CreateStoryModalComponent,StoryViewListPopupComponent,StoriesPanelComponent],
})
export class SharedModule {
  constructor() {

  }
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers:[BsModalRef,ExternalLibraryService,
        {
          provide: PERFECT_SCROLLBAR_CONFIG,
          useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        }
      ]
    }
  }
}
